import { AsyncAction } from "actions/types";
import {
  AlertArguments,
  AlertButtons,
  AlertType,
  DISMISS_ALERT,
  DismissAlertAction,
  GENERATE_ALERT,
  GenerateAlertAction
} from "./types";

const ALERT_TIMEOUT = 5000;
let alertTimer: number;

function generateAlert(
  message: unknown, buttons: AlertButtons, alertType: AlertType
): GenerateAlertAction {
  return {
    type: GENERATE_ALERT,
    alertType,
    message,
    buttons
  };
}

export function dismissAlert(): DismissAlertAction {
  return {
    type: DISMISS_ALERT
  };
}


// Async actions

function setAlertTimer(): AsyncAction {
  return (dispatch) => {
    alertTimer = setTimeout(() => {
      dispatch(dismissAlert());
    }, ALERT_TIMEOUT);
  };
}

export function createAlert(args: AlertArguments): AsyncAction {
  const { response, buttons, alertType } = args;
  let { message } = args;

  message = message || response.data.message;

  return (dispatch, getState) => {
    if (getState().alert.isVisible) {
      clearTimeout(alertTimer);
      dispatch(dismissAlert());

      if (!buttons) {
        dispatch(setAlertTimer());
      }

      dispatch(generateAlert(message, buttons, alertType));
    } else {
      dispatch(generateAlert(message, buttons, alertType));
      clearTimeout(alertTimer);
      dispatch(setAlertTimer());
    }
  };
}
